import React from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import ValidationContent from './ValidationContent';
import './ModalValidacionFirma.scss';

/**
 * Modal para mostrar el resultado de la validación de firma
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @param {Object} props.validationData - Datos de validación de la firma
 * @returns {React.ReactElement} - Componente ModalValidacionFirma
 */
const ModalValidacionFirma = ({ show, onClose, validationData }) => (
  <AUIModal
    size="xxl"
    show={show}
    title="Validar firma"
    actionButtons={[
      {
        id: 'tertiary',
        mode: 'tertiary',
        label: 'Volver',
        onClick: onClose,
        disabled: false,
      },
    ]}
    onClose={onClose}
  >
    <ValidationContent validationData={validationData} />
  </AUIModal>
);

ModalValidacionFirma.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  validationData: PropTypes.shape({
    nombreFirmante: PropTypes.string,
    fechaFirma: PropTypes.string,
    fechaValidacion: PropTypes.string,
    estadoFirma: PropTypes.string,
    contenidoAlterado: PropTypes.bool,
    certificadoCaducado: PropTypes.bool,
    certificadoRevocado: PropTypes.bool,
    certificadoCa: PropTypes.bool,
  }),
};

ModalValidacionFirma.defaultProps = {
  validationData: null,
};

export default ModalValidacionFirma;
